const loginPath = '/auth/'
const passwordRecoveryPath = '/password-recovery/'
const userInfo = '/user_info/'
const childInfoPath = (userId) => `/child/${userId}/`
const parentInfoPath = (userId) => `/parent/${userId}/`
const registerChildPath = `/register/child/`
const childrenInfoPath = (userId) => `/parent/${userId}/getChildren/`
const refreshToken = `/refresh/`;

//TODO: remove modules from here
const modulesListPath = '/module/';

export default {
  loginPath,
  passwordRecoveryPath,
  registerChildPath,
  userInfo,
  modulesListPath,
  childrenInfoPath,
  childInfoPath,
  parentInfoPath,
  refreshToken,
};
